// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {ApolloQueryResult} from 'apollo-client';
import React, {useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from 'semantic-ui-react';

import {
  EntityQuery,
  useUpdateEntityAdminMutation,
} from '../../generated/graphql';
import {TeamSettingsPageEntity} from '../../graphql/teamQuery';

type TeamPaidToggleProps = {
  entity: TeamSettingsPageEntity | EntityQuery['entity'];
  onUpdate: () => Promise<ApolloQueryResult<EntityQuery>>;
};

const TeamPaidToggle = ({entity, onUpdate}: TeamPaidToggleProps) => {
  const [updateEntityAdmin] = useUpdateEntityAdminMutation();
  const [checked, setChecked] = useState(entity?.isPaid ?? false);

  return (
    <Tailwind>
      <div className="m-4">
        <Checkbox
          toggle
          label="Paid"
          checked={checked}
          onChange={async () => {
            const newPaidStatus = !checked;
            try {
              await updateEntityAdmin({
                variables: {
                  entityName: entity?.name ?? '',
                  isPaid: newPaidStatus,
                },
              });
              // update the local state after successful mutation
              setChecked(newPaidStatus);
              toast(`successfully updated paid status`);
              onUpdate();
            } catch (e) {
              console.error(e);
              toast('Error updating paid status', {type: 'error'});
              // revert the local state to the previous value
              setChecked(checked);
            }
          }}
        />
      </div>
    </Tailwind>
  );
};

export default TeamPaidToggle;
